module.exports = __webpack_public_path__ + "static/media/benefitsofdrone.339ae9cb.png";